(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    

$('.product-images').slick({
    arrows: false,
    autoplay: true,
    dots: true,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 768,
            settings: "unslick"
        }
    ]
});


  } catch(e) { console.error(e); }
})();
})();
